import { render, staticRenderFns } from "./price-rule-set-show.vue?vue&type=template&id=40a335b3&scoped=true&"
import script from "./price-rule-set-show.vue?vue&type=script&lang=js&"
export * from "./price-rule-set-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a335b3",
  null
  
)

export default component.exports